"use client";
import { useFormik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { ERROR_MESSAGES } from "@/constants";
import { usePrice } from "@/hooks";
import {
  setCurrency,
  setEnteredDomainRes,
  setLoadindResourse,
  setResourceDomainRes,
  useGetDomainsListQuery,
  useLazyCheckDomainAvailabilityQuery,
  useLazyGetDomainResourceQuery,
} from "@/store";
import {
  domainValidate,
  removeFromLocale
} from "@/utils";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { PanelLayout } from "./Layout/PanelLayout";
import { PanelTitle } from "./Layout/PanelTitle";
import { Loader } from "./Loader";

const initialValues = {
  domainTDL: ".az",
  domainSDL: "",
};
const { WENT_WRONG } = ERROR_MESSAGES;

export const Domain = ({
  titleColourGroup = "whiteGroup",
  sectionName = "vps_hosting_table",
  nameSite,
  currency: curr,
  default_currency
}) => {
  const formatAmount = usePrice()
  const showWhois = nameSite === "sayt.az";
  const [loading, setLoading] = useState(false);
  const { data: domain } = useGetDomainsListQuery();
  const domainNames = nameSite == 'websiteca.com' ? domain?.body.filter((item) => !item.name.endsWith('.az')) : domain?.body;
  const t = useTranslations();
  const dispatch = useDispatch();
  const { curr: currency } = useSelector((state) => state.common) ?? default_currency;
  const [checkDomainAvailability, { data, isSuccess, isError }] =
    useLazyCheckDomainAvailabilityQuery();
  const [
    getDomainResource,
    {
      data: resourceData,
      isSuccess: isSuccessResource,
      isLoading: isLoadingResource,
    },
  ] = useLazyGetDomainResourceQuery();

  const searchDomainHandler = async (values) => {
    const { domainSDL, domainTDL } = formik?.values || {};
    const domainName = `${domainSDL}${domainTDL}`.toLowerCase();
    if (domainSDL && domainTDL) {
      setLoading(true);

      await checkDomainAvailability({
        domainName: domainName,
      });

      await getDomainResource({
        resourse: domainName,
      });
    }
  };
  useEffect(() => {
    dispatch(setEnteredDomainRes({}));
    removeFromLocale("domainName");
    removeFromLocale("summary");
    removeFromLocale("ns");
    searchDomainHandler();
  }, [currency]);

  useEffect(() => {
    if (isSuccess) {
      const el = document.querySelector(".scrollNew");
      setTimeout(() => {
        window.scrollTo({
          behavior: "smooth",
          top: el?.offsetTop,
        });
      }, 300);
      setLoading(false);
      dispatch(setEnteredDomainRes(data?.body));
      dispatch(setCurrency(data?.currency));
      removeFromLocale("domainName");
      removeFromLocale("summary");
      removeFromLocale("ns");
      dispatch(setLoadindResourse(true));
    }
    if (isError) {
      alert(WENT_WRONG);
      setLoading(false);
    }
  }, [isSuccess, data, isError, dispatch]);

  useEffect(() => {
    if (isSuccessResource && !isLoadingResource) {
      dispatch(setResourceDomainRes(resourceData?.body));
    }
  }, [dispatch, isSuccessResource, resourceData?.body, isLoadingResource]);

  const formik = useFormik({
    initialValues,
    validate: domainValidate,
    onSubmit: (values) => searchDomainHandler(values),
  });

  return (
    <>
      <PanelLayout>
        <div className="max-w-[656px] px-1 h-full mx-auto flex justify-center items-center flex-col homeScroll text-mainDarkPurple">
          <PanelTitle
            {...{ sectionName }}
            domainDesc={true}
            showWhois={showWhois}
            colourGroup={"grayGroup"}
          />

          <div className="mt-12 md:min-w-[680px] sm:min-w-[350px] sm:mx-4">
            <div className="relative  pl-[20px] shadow-sm bg-white rounded-lg text-mainDarkPurple border-[#DADCE0] border">
              <form
                onSubmit={formik?.handleSubmit}
                className="flex justify-between items-center"
              >
                <input
                  disabled={loading}
                  type="text"
                  name="domainSDL"
                  id="domainSDL"
                  value={formik.values?.domainSDL}
                  onChange={formik.handleChange}
                  className="scrollClass w-full mt-[1px] pr-3 h-full text-black outline-none focus-within:outline-none placeholder:text-slate-400 "
                  placeholder={t("placeholderDomain")}
                />
                <div className="flex justify-center items-center">
                  <div className="h-full">
                    <label htmlFor="domain" className="sr-only">
                      Domain Availability
                    </label>
                    <select
                      aria-label="domainTDL"
                      id="domainTDL"
                      name="domainTDL"
                      className="h-full bg-transparent border-0 border-l-[1px] text-slate-500 outline-none !p-0 xmd:!pr-8 !pl-2 w-fit  "
                      onChange={formik.handleChange}
                      value={formik.values.domainTDL}
                    >
                      {domainNames?.map(({ name, id }) => (
                        <option
                          className="sm:text-[13px] md:text-base font-medium text-slate-500 bg-mainBgPurple hover:!bg-mainLightPurple focus:!bg-mainLightPurple !accent-mainLightPurple  checked:!bg-mainLightPurple checked:text-white"
                          key={id}
                        >{`${name}`}</option>
                      ))}
                    </select>
                  </div>
                  <div className=" sm:min-w-[96px] min-w-[60px] min-h-[48px] items-center flex justify-center">
                    {loading ? (
                      <Loader fullscreen={false} size={40} />
                    ) : (
                      <div
                        onClick={formik.submitForm}
                        className="cursor-pointer bg-mainLightPurple hover:bg-mainLightPurpleHover active:bg-mainLightPurpleActive sm:px-6 px-2 text-white rounded-[4px] h-[48px] relative flex justify-center items-center"
                      >
                        <button className="p-1.5" type="submit">
                          {t("search")}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <p
              className={`text-base text-mainDarkPurple mt-2 leading-6`}
              style={{
                visibility: formik?.errors.domainSDL ? "visible" : "hidden",
              }}
            >
              *{formik?.errors.domainSDL || ""}
            </p>
            <div className="sm:grid sm:grid-cols-3 md:flex md:flex-row justify-between mt-8 md:gap-5">
              {domainNames?.map(({ name, cost, id }, index) => {
                if (index > 5) {
                  return;
                }
                const rigthBottom =
                  index < 2
                    ? "sm:border-r-[1px] sm:border-b-[1px] sm:border-[#FFFFFF40]"
                    : "";
                const bottom =
                  index === 2 ? "sm:border-b-[1px] sm:border-[#FFFFFF40]" : "";
                const right =
                  index === 3 || index === 4
                    ? "sm:border-r-[1px] sm:border-[#FFFFFF40]"
                    : "";
                return (
                  <React.Fragment key={id * 56}>
                    <div
                      onClick={() => formik.setFieldValue('domainTDL', name)}
                      className={`${rigthBottom + bottom + right
                        } sm:p-4 cursor-pointer  md:border-none  md:px-6 text-center`}
                      key={id * 2}
                    >
                      <div className="text-mainLightPurple font-semibold text-2xl">{name}</div>
                      <div className="text-mainLightPurple font-semibold">
                        {formatAmount(cost)}/{t("yr")}
                      </div>
                    </div>
                    {domainNames?.length != index + 1 ? (
                      <div className="sm:hidden md:border-l md:opacity-25 md:text-white">
                        &nbsp;
                      </div>
                    ) : null}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
      </PanelLayout>
    </>
  );
};
